import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GetServiceCaller, PostFormServiceCaller } from "../../../services/serviceCaller";
import { FaSpinner } from "react-icons/fa";

const LeaveEncashment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(updateNavbarHeading("Leaves Encashment"));
  }, []);

  const initialData = {
    EmployeeName: "",
    LeaveBalance: "",
    LeaveCarryForward: "",
    LeaveEncashment: "",
  };
  
  const [formData, setFormData] = useState(initialData);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true); // Added page loading state

  const fetchLeaveData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}leave/encashment`);
      if (response.status === 200) {
        const fetchData = response?.data?.data?.LeaveEncashment;
        const leaveData = {
          EmployeeName: fetchData?.EmployeeName,
          LeaveBalance: fetchData?.LeaveBalance,
          LeaveCarryForward: fetchData?.LeaveCarryForward,
          LeaveEncashment: fetchData?.LeaveEncashment,
        };
        setFormData(leaveData);
        setPageLoading(false); // Stop page loading when data is fetched
      }
    } catch (error) {
      if (error.response?.status === 400) {
        setError("You have already Submitted your leave encashment.");
      } else {
        setError("You have already Submitted your leave encashment.");
        console.error("Error fetching Leave:", error);
      }
      setPageLoading(false); // Stop loading even if there's an error
    }
  };
  
  useEffect(() => {
    fetchLeaveData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate LeaveCarryForward input
    if (name === "LeaveCarryForward") {
      const leaveCarryForward = parseInt(value) || 0;
      const leaveBalance = parseInt(formData.LeaveBalance) || 0;

      // Prevent values above 10
      if (leaveCarryForward > 10) {
        toast.error("Leave Carry Forward cannot be greater than 10.");
        return;
      }

      // Prevent LeaveCarryForward from exceeding LeaveBalance
      if (leaveCarryForward > leaveBalance) {
        toast.error("Leave Carry Forward cannot be greater than Leave Balance.");
        return;
      }
    }

    // Update the formData state
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };

      // Calculate LeaveEncashment when LeaveCarryForward changes
      if (name === "LeaveCarryForward") {
        const leaveCarryForward = parseInt(value) || 0;
        const leaveBalance = parseInt(prev.LeaveBalance) || 0;
        updatedFormData.LeaveEncashment = Math.max(leaveBalance - leaveCarryForward, 0);
      }

      return updatedFormData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { LeaveBalance, LeaveCarryForward, LeaveEncashment } = formData;
    const LeaveEncash = LeaveEncashment;
    const submitLeaveData = { LeaveBalance, LeaveCarryForward, LeaveEncash };

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}leave/encashment`,
        submitLeaveData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Leave Encashment submitted successfully!");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit form. Please try again later.");
      setLoading(false);
    }
  };

  // Show loader while page is loading
  if (pageLoading) {
    return (
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
        <div className="text-center">
          <FaSpinner className="spinner" style={{ fontSize: "3rem", animation: "spin 3s linear infinite" }} />
          <p className="mt-3">Loading...</p>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              .spinner {
                animation: spin 1s linear infinite;
              }
            `}
          </style>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div>
            {error ? (
              <div className="form-submit-alert" role="alert">
                <strong>{error}</strong>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label htmlFor="EmployeeName" className="form-label">
                        Employee
                      </label>
                      <input
                        type="text"
                        name="EmployeeName"
                        id="EmployeeName"
                        value={formData.EmployeeName}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label htmlFor="LeaveBalance" className="form-label">
                        Leave Balance
                      </label>
                      <input
                        type="text"
                        name="LeaveBalance"
                        id="LeaveBalance"
                        value={formData.LeaveBalance}
                        className="form-control text-end"
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label htmlFor="LeaveCarryForward" className="form-label">
                        Leave Carry Forward
                      </label>
                      <input
                        type="text"
                        name="LeaveCarryForward"
                        id="LeaveCarryForward"
                        value={formData.LeaveCarryForward}
                        onChange={handleChange}
                        className="form-control text-end"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label htmlFor="LeaveEncashment" className="form-label">
                        Leave Encash
                      </label>
                      <input
                        type="text"
                        name="LeaveEncashment"
                        id="LeaveEncashment"
                        value={formData.LeaveEncashment}
                        className="form-control text-end"
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div className="text-end">
                  <button 
                    type="submit" 
                    className="custom-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <FaSpinner className="sm-spinner me-2" style={{ animation: "spin 1s linear infinite" }} />
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveEncashment;